import ReconciliationLineItemBase from './base/ReconciliationLineItemBase';

/**
 * @class ReconciliationLineItem
 * @extends ReconciliationLineItemBase
 */
class ReconciliationLineItem extends ReconciliationLineItemBase {

}

export default ReconciliationLineItem;
